import { hmac256 } from "../utils/mainData";

// Helper functions to retrieve stored values
const getAuthToken = () => localStorage.getItem("authToken") || "";
const getInvoiceId = () => localStorage.getItem("invoiceId") || "";
const getDeviceid = () => localStorage.getItem("deviceUuid") || "";
const { REACT_APP_SECRET_KEY } = process.env;

/**
 * Generates a unique device ID and stores it in localStorage.
 * @returns The device ID.
 */
export const generateDeviceId = async () => {
  const { v4: uuidv4 } = require("uuid");
  let deviceUuid = getDeviceid();

  if (!deviceUuid) {
    deviceUuid = uuidv4();
    localStorage.setItem("deviceUuid", deviceUuid);
  }

  return deviceUuid;
};


/**
 * Generates authentication headers for API requests.
 * @param payload - The payload to be included in the signature.
 * @returns An object containing the headers.
 */
export const getAuthHeaders = async () => {
  const token = getAuthToken();
  const invoiceId = getInvoiceId();

  // console.log("token:", token);

  // Generate dynamic values
  const timestamp = Date.now().toString();
  // const deviceId = await generateDeviceId();
  const deviceId = 'Rico';
  const signature = await generateSignatureToken(invoiceId, timestamp, deviceId);

  // console.log("Authorization:", token ? `Bearer ${token}` : "");
  // console.log("X-TIMESTAMP:", timestamp);
  // console.log("X-DEVICE-ID:", deviceId);
  // console.log("X-INVOICE-ID:", invoiceId); // Add invoiceId if available
  // console.log("X-SIGNATURE:", signature);

  return {
    Authorization: token ? `Bearer ${token}` : "",
    "X-TIMESTAMP": timestamp,
    "X-DEVICE-ID": deviceId,
    "X-INVOICE-ID": invoiceId,
    "X-SIGNATURE": signature
  };
};
export const getHeaders = async (method?: string, url?: string) => {
  const token = getAuthToken();
  const invoiceId = getInvoiceId();

  // console.log("token:", token);

  // Generate dynamic values
  const timestamp = Date.now().toString();
  // const deviceId = await generateDeviceId();
  const deviceId = 'Rico';
  const signature = await generateSignature(method, url, token, deviceId, invoiceId, timestamp);

  // console.log("Authorization:", token ? `Bearer ${token}` : "");
  // console.log("X-TIMESTAMP:", timestamp);
  // console.log("X-DEVICE-ID:", deviceId);
  // console.log("X-INVOICE-ID:", invoiceId); // Add invoiceId if available
  // console.log("X-SIGNATURE:", signature);

  return {
    Authorization: token ? `Bearer ${token}` : "",
    "X-TIMESTAMP": timestamp,
    "X-DEVICE-ID": deviceId,
    "X-INVOICE-ID": invoiceId,
    "X-SIGNATURE": signature
  };
};

/**
 * Generates a signature using HMAC-SHA256 encryption.
 * @param payload - The payload to be included in the signature.
 * @param timestamp - The current timestamp.
 * @param deviceId - The device ID.
 * @returns The generated signature.
 */
export const generateSignature = async (method?: string, url?: string, token?: string, deviceId?: string, invoiceId?: string, timestamp?: string) => {

  // Concatenate the values for the signature
  const rawData = `${method}`+":"+`${url}`+":"+`${token}`+":"+`${deviceId}`+":"+`${invoiceId}`+":"+`${timestamp}`;
  const secretKey = REACT_APP_SECRET_KEY;

  // console.log("Raw Data:", rawData);
  // console.log("Secret Key:", secretKey);

  const signature = hmac256(rawData, secretKey);
  // console.log("HMAC-SHA256 Signature:", signature);

  return signature;
};
export const generateSignatureToken = async (invoiceId: any, timestamp: string, deviceId: string) => {

  // Concatenate the values for the signature
  const rawData = `${deviceId}`+":"+`${invoiceId}`+":"+`${timestamp}`;
  const secretKey = REACT_APP_SECRET_KEY;

  // console.log("Raw Data:", rawData);
  // console.log("Secret Key:", secretKey);

  const signature = hmac256(rawData, secretKey);
  // console.log("HMAC-SHA256 Signature:", signature);

  return signature;
};